import React, { useEffect, useState } from "react";
import axios from "axios";
import KpiCard from "../RuleCatalogue/KpiCard";
import Tables from "../RuleCatalogue/Tables";
import heartLoading from "../../assests/heartLoading.gif";
import SavedFilters from "./SavedFilters";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const SavedRuleCatalogue = ({
  dashboardId,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const buildQueryString = () => {
    let params = [];

    params.push(`page=${page}`);
    params.push(`pageSize=10`);

    Object.entries(currentFilters).forEach(([key, value]) => {
      if (!value) return;
      params.push(`filter=${key}=${value}`);
    });

    if (searchTerm) params.push(`search=${searchTerm}`);

    return params.join("&");
  };
  const getProductName = () => {
  try {
    const name = localStorage.getItem("selectedProductName");
    if (name && name.trim()) {
      return name
        .trim()
        .replace(/[^a-zA-Z0-9\s-_]/g, "")
        .replace(/\s+/g, "_");
    }
  } catch (error) {
    console.warn("Error reading product name:", error);
  }
  return "Product";
};

const getTimestamp = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  const h = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  const s = String(now.getSeconds()).padStart(2, "0");
  return `${y}${m}${d}_${h}${min}${s}`;
};
const handleExport = async () => {
  try {
    const res = await axios.get(
      `${BASE_URL}/view-rule-catalouge/${dashboardId}`,
      {
        params: {
          page: 1,
          pageSize: 10000,  // full dataset
          ...currentFilters,
          search: searchTerm,
        }
      }
    );

    const dataToExport = res.data.tableData || [];

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rules");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, `${getProductName()}_${getTimestamp()}.xlsx`);
  } catch (error) {
    console.error("Export error:", error);
  }
};


  useEffect(() => {
    if (!dashboardId) return;

    const loadData = async () => {
      setLoading(true);

      try {
        const qs = buildQueryString();
        const response = await axios.get(
          `${BASE_URL}/view-rule-catalouge/${dashboardId}?${qs}`
        );

        setData(response.data);

        if (response.data.filters) onFiltersChange(response.data.filters);
        if (response.data.search_term) onSearchChange(response.data.search_term);

      } catch (error) {
        console.error("Error loading saved rule catalogue", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [dashboardId, page]);

  if (!data || loading) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center w-full h-full">
        <div className="flex flex-col items-center space-y-3">
          <img src={heartLoading} className="h-32" alt="Loading..." />
          <span className="text-gray-700 text-lg">Loading saved view…</span>
        </div>
      </div>
    );
  }

  return (
    <div className="rule-catalogue">

      <SavedFilters
        savedFilters={data.filters}
      />

      {/* KPI Cards */}
      <KpiCard rules={data.rules} />

      {/* Table */}
      <Tables
        tableData={data.tableData}
        pagination={data.pagination}
        onPageChange={setPage}
          onExport={handleExport}  

      />
    </div>
  );
};

export default SavedRuleCatalogue;
